import React, { forwardRef } from 'react';
import { MDInputRoot, MDInputRootProps } from './MDInputRoot';
import { FFTheme } from '../../assets/theme';

export type MDInputProps = MDInputRootProps & {
  success?: boolean;
  theme?: FFTheme;
};

const MDInput = forwardRef<HTMLInputElement, MDInputProps>(
  ({ error = false, success = false, disabled = false, ...rest }, ref) => (
    <MDInputRoot
      {...rest}
      ref={ref}
      disabled={disabled}
      error={error}
      success={success}
    />
  )
);

MDInput.displayName = 'MDInput';

export { MDInput };
